// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"5dff5746","343":"889fcd37"}[chunkId] + ".chunk.js";
};